import colors from "../../Theme/base/colors";
import pxToRem from "../../Theme/functions/pxToRem";

const { background } = colors;

export default {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      padding: `${pxToRem(4)}  ${pxToRem(12)} !important`,
      backgroundColor: background.default,
      borderRadius: "8px",
      border: "none !important",
      width: "100%",

      "&:focus , .Mui-selected": {
        backgroundColor: background.default,
      },
      "&.Mui-disabled": {
        border: "none !important",
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      display: "block",
      "&.MuiSvgIcon-root": {
        fontSize: "25px !important",
      },
    },
  },
};
